<template>
  <div class="px-4 py-2">
    <div class="mt-2 w-full">
      <div
        class="lg:flex grid-cols-1 lg:space-y-0 space-y-3 gap-5 justify-between"
      >
        <div>
          <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
            Temperatur & Humidity
          </h1>
        </div>
        <div class="flex gap-2">
          <div>
            <Dropdown placement="" class="">
              <template v-slot:button>
                <button class="flex px-3 py-1 w-full rounded-md bg-primary text-white">
                   Greenhouse - E2
                  <span class="ml-5 mt-1"
                    ><Icon icon="ant-design:caret-down-filled"
                  /></span>
                </button>
              </template>
              <template v-slot:content>
                <div class="text-wrap">
                  <a
                    v-on:click="select = 'All',selectId=0,getMemberGroup(dataGroupDetail?.id)"
                    class="block hover:bg-primary hover:text-white px-4 py-2"
                    >E2</a
                  >
                  <a v-for="(item, index) in dataGroupDetail?.Classifications" :key="index"
                    v-on:click="select = item.name,selectId=item.id,getMemberGroup(dataGroupDetail?.id,item.id)"
                    class="block mt-4 hover:bg-primary hover:text-white px-4 py-2"
                    >{{ item.name }}</a
                  >
                </div>
              </template>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col md:flex-row h-auto gap-4 mt-4">
      <div class="md:w-1/3 w-full max-h-[300px] md:max-h-full overflow-y-auto p-4 border rounded-lg bg-white dark:bg-gray-800 dark:border-gray-800">
        <ul class="space-y-2">
          <li
            v-for="(sensor, index) in dataAnySensor"
            :key="index"
            @click="setActive(index,sensor)"
            :class="[
              'p-2 rounded cursor-pointer transition-colors flex justify-between',
              activeSensor === index
                ? 'bg-blue-600 text-white hover:bg-blue-600 dark:bg-blue-600'
                : 'bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600'
            ]"
          >
            <p class="m-0 dark:text-white">{{ sensor.name }}</p>
            <div v-if="activeSensor === index" class="flex items-center">
              <svg class="w-4 h-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 14">
                <path stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"/>
              </svg>
            </div>
          </li>
        </ul>
      </div>

      <!-- Kanan: Grafik (2/3 di desktop, full di mobile) -->
      <div class="md:w-2/3 w-full p-4 border rounded-lg bg-white dark:bg-gray-800 dark:border-gray-800">
        <div>
          <Chart :plantId="sensorChose?.id" :page=false />
        </div>
        <div class="space-y-2">
          <div class="flex justify-between items-center grid md:grid-cols-4 grid-cols-2">
            <div>
              <p class="text-sm text-gray-600 dark:text-gray-300">Temperature</p>
              <p class="text-lg font-semibold text-gray-800 dark:text-white">{{ dataRealtimeSuhu[sensorChose?.sensorTemp] }} °C</p>
            </div>
            <div>
              <p class="text-sm text-gray-600 dark:text-gray-300">Humidity</p>
              <p class="text-lg font-semibold text-gray-800 dark:text-white">{{ dataRealtimeSuhu[sensorChose?.sensorHumi] }} %</p>
            </div>
            <div>
              <p class="text-sm text-gray-600 dark:text-gray-300">Temperature AVG</p>
              <p class="text-lg font-semibold text-gray-800 dark:text-white">{{ dataRealtimeSuhu.u1 }} °C</p>
            </div>
            <div>
              <p class="text-sm text-gray-600 dark:text-gray-300">Humidity AVG</p>
              <p class="text-lg font-semibold text-gray-800 dark:text-white">{{ dataRealtimeSuhu.u2 }} %</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { useCounterStore } from "@/store/counter";
  import { mapActions, mapState } from "pinia";
  import Dropdown from "@/components/Dropdown.vue";
  import { Icon } from "@iconify/vue";
  import Chart from "./Chart.vue";

  export default {
    name: "Dashboard",
    components: {
      Dropdown,Icon,Chart
    },
    data() {
      return {
        data: null,
        sensorChose: null,
        activeSensor: 0,
        groupedSensors: []
      };
    },
    methods: {
      ...mapActions(useCounterStore,['getRealtimeSensorSuhu', 'getAnySensor',]),
      setActive(index,dataSen) {
        this.activeSensor = index
        this.sensorChose = dataSen
      },
    },
    computed: {
      ...mapState(useCounterStore,['dataAnySensor','dataRealtimeSuhu']),
      
    },
    created(){
      this.getAnySensor()
     this.getRealtimeSensorSuhu()
    },
    watch: {
      dataAnySensor(newVal) {
        if (newVal) {
          this.sensorChose = this.dataAnySensor[0]
        }
      }
    },
  };
</script>
